export const thankYouDetailsMock = {
  compensation: 2,
  compensation_currency: 'EUR',
  compensation_type: 'monetary_provided_by_system',
  thank_you: {
    title: 'Thank You Title',
    message: 'Thank You Message',
  },
  organization_name: 'Hotjar',
  compensation_paid_by_system: false,
};
